<!--  -->
<template>
    <div class="title-box">
       <div class="main-title">
            <img src="../../assets/images/title_line01.png" alt="">

               {{mainTitle}} 

            <img src="../../assets/images/title_line02.png" alt="">
        </div>
       <div class="vice-title">{{viceTitle}}</div>
    </div>
  </template>
  
  <script>
  export default {
    name: '',
    data () {
      return {
      }
    },
  
    props: ["mainTitle", "viceTitle"],
  
    watch: {},
  
    components: {},
  
    computed: {},
  
    created () {},
  
    methods: {}
  }
  
  </script>
  <style lang='scss' scoped>
  .title-box {
     text-align: center;
    .main-title {
      color: #333;
      font-size: 28px;
      line-height: 40px;
      font-weight: bold;
      margin-bottom: 12px;
      img{
        vertical-align: middle;
      }
    }
    .vice-title {
        font-size: 20px;
        color: #222222;
        line-height: 20px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/header/pictureTitle.vue